import React from 'react';

export default function Loading() {
    return (
        <div style={{width: '100%', height: '100%', backgroundColor: '#fff', justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column'}}>
            <img style={{width: 180, height: 130}} src="/loading.gif" />
            <span>Carregando...</span>
        </div>
    )
}